import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div
      className="
  three-fourths
  columns
  medium-down--one-whole
  offset-by-two
  is-hidden-offset-mobile-only
"
    >
      <h1>Shipping</h1>
      <div className="feature-divider" />
      <div className="rte">
        <h3>
          <em>
            <strong />
          </em>
        </h3>
        <p>A flat shipping fee of $9.99 USD applies to every order.</p>
        <p>
          Orders are usually prepared within 1–3 business days. Estimated
          transit time is normally 5–12 business days after dispatch, depending
          on the destination and local carrier conditions.
        </p>
        <p>
          Please provide a complete street address. We cannot deliver to P.O.
          boxes or to destinations that are unavailable due to applicable
          sanctions, carrier restrictions or payment-service rules.
        </p>
        <p>
          Tracking information is provided when it is available. Destination
          taxes or handling fees may be the customer’s
          responsibility unless checkout states otherwise.
          <br />
          <br />
          <br />
          <br />
          <strong>CONTACT US</strong>
          <br />
          <br />
          Email us at{" "}
          <a
            href="mailto:model@baplehollow.online"
            title="Email baplehollow"
            target="_blank"
            rel="noreferrer"
          >
            model@baplehollow.online
          </a>
          &nbsp;with delivery questions.
        </p>
      </div>
    </div>
  );
}

export default Delivery;
